// Session policy (client side, complements JWT expiry):
//  - "Manter conectado": token válido por 30 dias, renovado diariamente enquanto em uso (POST /auth/refresh)
//  - sem a opção: expira após 8h de inatividade
//  - área administrativa: expira após 30 min de inatividade
const ADMIN_PREFIXES = ["/users", "/queues", "/sectors", "/os-types", "/os-statuses", "/channels", "/chat-flows", "/branding", "/audit", "/tenants"];
const H = 60 * 60 * 1000;
export const LIMITS = { normal: 8 * H, admin: 30 * 60 * 1000, refreshAfter: 24 * H };

export const isAdminArea = (path = window.location.pathname) => ADMIN_PREFIXES.some((p) => path.startsWith(p));
export const touch = () => localStorage.setItem("os_last_activity", String(Date.now()));
export const lastActivity = () => Number(localStorage.getItem("os_last_activity") || 0);
export const remembered = () => localStorage.getItem("os_remember") === "1";

export function sessionExpired() {
  if (!localStorage.getItem("os_token")) return false;
  const idle = Date.now() - (lastActivity() || Date.now());
  if (isAdminArea()) return idle > LIMITS.admin;
  return !remembered() && idle > LIMITS.normal;
}

export function tokenIssuedAt() {
  try { return JSON.parse(atob(localStorage.getItem("os_token").split(".")[1])).iat * 1000; } catch { return 0; }
}

export function endSession(reason) {
  ["os_token", "os_user", "os_tenant", "os_remember", "os_last_activity"].forEach((k) => localStorage.removeItem(k));
  if (reason) sessionStorage.setItem("os_logout_reason", reason);
  window.location.replace("/login");
}
